import { ITutorPersonalDetails } from '@wot/typings';
import { useAppDispatch, useAppSelector } from '../../../hooks/useRedux';
import { updateProfile } from '../../../reducers/profileSlice';
import PersonalDetailsComponent from '../../ProfileSetup/containers/Personal/PersonalDetailsComponent';
import { toast } from 'react-toastify';
export default function Personal() {
  const { profile } = useAppSelector((state) => state.profileSlice);
  const dispatch = useAppDispatch();
  const onSavePersonal = async (data: ITutorPersonalDetails) => {
    dispatch(updateProfile({ personal: data, status: 'under-review' })).then(() => {
      toast.success('Personal Details updated');
    });
  };

  return (
    <div className="relative max-w-5xl pb-20 md:pb-0">
      <PersonalDetailsComponent personal={profile?.personal} onSave={onSavePersonal} />
    </div>
  );
}
